import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const RegistrationPrompt = ({ isLoading }) => {
  const navigate = useNavigate();

  return (
    <div className="mt-8 pt-6 border-t border-border">
      <div className="text-center">
        <div className="bg-muted/30 rounded-lg p-6">
          <div className="flex justify-center mb-4">
            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
              <Icon name="UserPlus" size={24} className="text-primary" />
            </div>
          </div>

          <h3 className="text-lg font-semibold text-foreground mb-2">New to HireBroker?</h3>

          <p className="text-sm text-muted-foreground mb-4">
            Create a free user account to save favorites, post property needs, and get matched
            with verified real estate agents.
          </p>

          <div className="space-y-3">
            <Button
              variant="outline"
              size="default"
              onClick={() => navigate('/register')}
              disabled={isLoading}
              iconName="ArrowRight"
              iconPosition="right"
              className="w-full sm:w-auto"
            >
              Create User Account
            </Button>

            <p className="text-xs text-muted-foreground">
              Agent, broker, or advisor?{' '}
              <Link to="/pro/register" className="text-primary font-medium hover:underline">
                Real Estate Agent registration
              </Link>
            </p>

            <div className="flex items-center justify-center space-x-4 text-xs text-muted-foreground">
              <div className="flex items-center space-x-1">
                <Icon name="Check" size={14} className="text-success" />
                <span>Free to join</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="Check" size={14} className="text-success" />
                <span>Save properties</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="Check" size={14} className="text-success" />
                <span>Specific Property Request</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationPrompt;
